import { useSelector } from 'react-redux';
import { selectProduct } from '../../../../../store/selectors/products';
import { mapProductToLogo } from '../../Products/helpers';

const Name = () => {
  const { data } = useSelector(selectProduct);
  const { name, content } = data;

  const Logo = mapProductToLogo(name);

  return (
    <div className='integration__name'>
      <Logo />

      <strong>{content.title}</strong>
    </div>
  );
};

export default Name;
